@if (!!gameId && !error) {
  <div class="game" [class.mobile]="isMobile$ | async">
    @if (gameId && gameInfoReady) {
      <gamelib-slides-nav
        [gameId]="gameId"
        (changeSlide)="onSlideChange($event)"
        >
        @if (isMobile$ | async) {
          <div class="modal-close" (click)="onClose()">
            <svg width="12" height="12" viewBox="0 0 12 12" stroke="#A4B0C3">
              <use [attr.xlink:href]="svgSetIcon('close-sidebar')"></use>
            </svg>
          </div>
        }
      </gamelib-slides-nav>
    }
    @if (gameId && gameInfoReady) {
      <gamelib-slides-body
        [gameId]="gameId"
        [screenOptions]="screenOptions"
        (close)="onClose()"
        (selectedText)="onTextSelect($event)"
        (answerState)="onIsAnswerChecked($event)"
        (allSlidesLoaded)="onAllSlidesLoaded()"
        >
        @if (isLesson) {
          <app-lesson-finish
            finish
            [hidden]="!isFinish"
            [author]="author"
            [lessonId]="_lessonId"
            [game]="game"
            [isShowConfirmation]="isFinished"
            (submitted)="onSubmitReview()"
            (authorRedirect)="onOpenAuthorPage()"
            (close)="onClose()"
          ></app-lesson-finish>
        }
        @if (isVocabulary) {
          <app-vocabulary-finish
            finish
            [hidden]="!isFinish"
            [game]="game"
            [isShowConfirmation]="isFinished"
            (close)="onClose()"
          ></app-vocabulary-finish>
        }
      </gamelib-slides-body>
    }
    <!--  Temp hide -->
    <!--  <app-vocabulary-add-->
    <!--    [data]="selectedText"-->
    <!--    [subject_id]="game.language_id!"-->
  <!--  ></app-vocabulary-add>-->
</div>
}
@if ((!gameId || error) && loaded) {
  <app-no-data></app-no-data>
}
